export const PROMO_IPHONE_18_IMAGES_URL = 'https://storage.yandexcloud.net/tf-bitrix-upload/iport/iphone-18'
